/** Which build of the app is running, and which the site serves now (see new-version.tsx). No JSX, so it can be tested. */

/** The build this page is running (the ?v= on its app.js), or undefined in dev and the demo. */
export function loadedBuild(): string | undefined {
  const src = document.querySelector<HTMLScriptElement>('script[src*="app.js"]')?.src ?? "";
  return /[?&]v=([a-z0-9]+)/.exec(src)?.[1];
}

/** The build the site serves now, from its page. */
export function servedBuild(html: string): string | undefined {
  return /app\.js\?v=([a-z0-9]+)/.exec(html)?.[1];
}
